import React from "react";
import { Routes, Route } from "react-router-dom";

import SupplierDetails from "./supplierDetails.page";
import FacilityDetails from "./facilityDetails.page";
import AuditDetails from "./auditDetails.page";
import ResourcesPage from "./resources.page";
import TodoPage from "./todo.page";
import FormDetailPage from "./formDetail.page";
import FormSubmissionSuccess from "./FormSubmissionSuccess.page";
import MaterialDetails from "./materialDetails.page";
import WIPPage from "./wip.page";
import WIPTrackerDetails from "./wipTrackerDetails.page";
import WIPBatchViewPage from "./wipBatchView.page";
import WIPBatchListPage from "./wipBatchList.page";

const IndexPage = () => {
  return (
    <Routes>
      <Route path="/suppliers" element={<SupplierDetails />} />
      <Route path=":factoryId" element={<FacilityDetails />} />
      <Route path=":factoryId/audit/:auditId" element={<AuditDetails />} />
      <Route path="/resources" element={<ResourcesPage />} />

      <Route path="/todo" element={<TodoPage />} />
      <Route path="/resources" element={<ResourcesPage />} />
      <Route path="/form/:formId" element={<FormDetailPage />} />
      <Route
        path="/form-submission-success"
        element={<FormSubmissionSuccess />}
      />
      <Route path="/material/:materialId" element={<MaterialDetails />} />
      <Route
        path="/suppliers/:supplierId/material/:materialId"
        element={<MaterialDetails />}
      />

      {/* WIP routes */}
      <Route path="/wip" element={<WIPPage />} />
      <Route path="/wip/details" element={<WIPTrackerDetails />} />
      <Route path="/wip/:wipId" element={<WIPBatchViewPage />} />
      <Route path="/wip/batch-list" element={<WIPBatchListPage />} />
    </Routes>
  );
};

export default IndexPage;
